import React from 'react'

import './MainBanner.scss'

export const MainBanner = ({
  children, backgroundURL, mainTitle, secondaryTitle,
  renderBreadcrumb, className, video, withoutOverlay,
}) => {

  const styles = {
    backgroundImage: `url(${backgroundURL})`,
  }
  return <div className={`main-banner-container ${className || ''}`} style={styles}>
    {!!renderBreadcrumb && renderBreadcrumb()}
    {mainTitle && <h1>{mainTitle}</h1>}
    {secondaryTitle && <h2>{secondaryTitle}</h2>}
    <div className='search-box-container'>
      {children}
    </div>
    {!withoutOverlay && <div className='main-banner-overlay'></div>}
    {video &&
      <div className='video-container'>
        <video playsinline autoPlay muted loop poster='polina.jpg' id='bgvid'>
          {/* <source src='polina.webm' type='video/webm' /> */}
          <source src='assets/videos/bg_video.mp4' type='video/mp4' />
        </video>
      </div>}
  </div>
}



// WEBPACK FOOTER //
// ./src/features/commons/MainBanner/MainBanner.component.js